<template>
  <div class="opreations">
    <div class="_left">
      <div class="list-heading">
        <span class="list-heading__icon">
          <a-icon type="unordered-list" />
        </span>
        <div class="list-heading__text">
          <h3>{{ displayTableTitle }}</h3>
          <span
            v-if="crud.page && crud.page.total !== undefined"
            class="list-heading__meta"
          >
            共 {{ crud.page.total || 0 }} 条记录
          </span>
        </div>
      </div>
    </div>
    <div class="_right">
      <div class="btns">
        <slot name="left"></slot>
        <a-button
          v-if="crud.optShow.add"
          v-permission="crud.permission.add"
          :disabled="checkOperateDisable(`新增${tableName}`)"
          icon="plus"
          type="primary"
          @click="toAdd"
        >
          {{ crud.addText }}
        </a-button>
        <a-button
          v-if="crud.optShow.edit"
          v-permission="crud.permission.edit"
          :disabled="
            crud.selections.length !== 1 ||
              checkOperateDisable(`修改${tableName}`)
          "
          icon="edit"
          type="dashed"
          @click="crud.toEdit(crud.selections[0])"
        >
          修改
        </a-button>
        <a-button
          v-if="crud.optShow.del"
          v-permission="crud.permission.del"
          :disabled="
            crud.selections.length === 0 ||
              checkOperateDisable(`删除${tableName}`)
          "
          :loading="crud.delAllLoading"
          icon="delete"
          type="danger"
          @click="toDelete(crud.selections)"
        >
          删除
        </a-button>
        <!-- <a-dropdown
          v-permission="crud.permission.download"
          v-if="crud.optShow.download"
        > -->
        <a-button
          v-if="crud.optShow.download"
          v-permission="crud.permission.download"
          :disabled="checkOperateDisable(`导出${tableName}`)"
          :loading="crud.downloadLoading"
          icon="download"
          type="link"
          @click="crud.doAllExport"
        >
          导出
        </a-button>
        <!-- <a-menu slot="overlay">
            <a-menu-item @click="crud.doExport">导出选中数据</a-menu-item>
            <a-menu-item @click="crud.doAllExport">全部导出</a-menu-item>
          </a-menu>
        </a-dropdown> -->
      </div>
      <div class="ops">
        <a-tooltip
          :disabled="checkOperateDisable(`查询${tableName}列表`)"
          placement="top"
          @click="crud.resetQuery()"
        >
          <template slot="title">
            <div>刷新</div>
          </template>
          <a-icon type="reload" class="ops-icon" />
        </a-tooltip>
        <ColumnSetting :table-key="resolvedTableKey" />
      </div>
    </div>
  </div>
</template>
<script>
import { crud } from "@crud/crud"
import ColumnSetting from "./ColumnSetting.vue"
import {
  checkMultiTypeOperateDisable,
  checkOperateDisable
} from "@/router/permission"

export default {
  components: {
    ColumnSetting
  },
  mixins: [crud()],
  props: {
    tableName: {
      type: String,
      defalut: () => {
        return ""
      }
    },
    queryFuncName: {
      type: String,
      defalut: () => {
        return ""
      }
    },
    /** 列设置存储 key，默认使用路由 name */
    tableKey: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayTableTitle() {
      const name = this.tableName || ""
      return name.endsWith("列表") ? name : `${name}列表`
    },
    resolvedTableKey() {
      return (
        this.tableKey ||
        (this.$route && this.$route.name) ||
        this.crud.title ||
        "default"
      )
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    checkMultiTypeOperateDisable,
    checkOperateDisable,
    toDelete(datas) {
      let _this = this
      this.$confirm({
        title: "提示",
        content: `确认删除选中的${datas.length}条数据?`,
        onOk() {
          _this.crud.delAllLoading = true
          _this.crud.doDelete(datas)
        },
        onCancel() {}
      })
    },
    toAdd() {
      let _this = this
      if (_this.$listeners["toDiyAdd"]) {
        _this.$emit("toDiyAdd")
      } else {
        this.crud.toAdd()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.opreations {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 56px;
  padding: 10px 20px;
  line-height: 1.4;

  ._left {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .list-heading {
      display: flex;
      align-items: center;
      min-width: 0;

      &__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 34px;
        width: 34px;
        height: 34px;
        margin-right: 10px;
        color: #1677ff;
        font-size: 15px;
        background: linear-gradient(145deg, #eef6ff, #e4f0ff);
        border: 1px solid #d9eaff;
        border-radius: 9px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
      }

      &__text {
        display: flex;
        flex-direction: column;
        min-width: 0;
      }

      h3 {
        margin: 0;
        color: #172033;
        font-size: 15px;
        font-weight: 650;
        line-height: 20px;
        letter-spacing: 0.01em;
      }

      &__meta {
        margin-top: 2px;
        color: #929db0;
        font-size: 11px;
        line-height: 15px;
        font-variant-numeric: tabular-nums;
      }
    }
  }

  ._right {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btns {
      display: flex;
      align-items: center;
      margin-right: 16px;
      position: relative;
      padding-right: 16px;

      & > * {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }

      &::after {
        display: block;
        content: "";
        position: absolute;
        width: 1px;
        height: 20px;
        background-color: #e6ebf2;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }

    .ops {
      display: flex;
      align-items: center;
      gap: 4px;

      & > * {
        cursor: pointer;
        margin-right: 0;
      }

      .ops-icon,
      ::v-deep .column-setting-trigger {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border: 1px solid #e4eaf2;
        border-radius: 7px;
        background: #fff;
        color: #6b7a90;
        font-size: 15px;
        box-shadow: 0 1px 2px rgba(15, 35, 52, 0.04);
        transition: all 0.18s ease;

        &:hover {
          color: #1677ff;
          background: #f2f7ff;
          border-color: #b9d8ff;
          box-shadow: 0 3px 8px rgba(22, 119, 255, 0.12);
          transform: translateY(-1px);
        }
      }
    }
  }
}
</style>
